import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';

//通知公告
export function queryWorkbench(_x, _x2) {
  return _queryWorkbench.apply(this, arguments);
}

//最新公文
function _queryWorkbench() {
  _queryWorkbench = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(page, limit) {
    var data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          data = {
            currentNo: page,
            pageSize: limit
          };
          return _context.a(2, request("/work/queryWorkbench", METHOD.POST, data));
      }
    }, _callee);
  }));
  return _queryWorkbench.apply(this, arguments);
}
export function queryNewDocument(_x3, _x4) {
  return _queryNewDocument.apply(this, arguments);
}

//系统通知
function _queryNewDocument() {
  _queryNewDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(page, limit) {
    var data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          data = {
            currentNo: page,
            pageSize: limit
          };
          return _context2.a(2, request("/newDocument/queryNewDocument", METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _queryNewDocument.apply(this, arguments);
}
export function querySystemNotice(_x5, _x6) {
  return _querySystemNotice.apply(this, arguments);
}

//待办
function _querySystemNotice() {
  _querySystemNotice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(page, limit) {
    var data;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          data = {
            currentNo: page,
            pageSize: limit
          };
          return _context3.a(2, request("/systemNotice/querySystemNotice", METHOD.POST, data));
      }
    }, _callee3);
  }));
  return _querySystemNotice.apply(this, arguments);
}
export function toDoList(_x7, _x8) {
  return _toDoList.apply(this, arguments);
}

//待阅
function _toDoList() {
  _toDoList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(page, limit) {
    var data;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          data = {
            currentNo: page,
            pageSize: limit
          };
          return _context4.a(2, request("/flowable/task/todoList", METHOD.POST, data));
      }
    }, _callee4);
  }));
  return _toDoList.apply(this, arguments);
}
export function queryFlowCopyMan(_x9, _x0, _x1) {
  return _queryFlowCopyMan.apply(this, arguments);
}

//天气
function _queryFlowCopyMan() {
  _queryFlowCopyMan = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(page, limit, param) {
    var data;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          data = {
            currentNo: page,
            pageSize: limit
          };
          return _context5.a(2, request('/flow/queryFlowCopyMan', METHOD.POST, data));
      }
    }, _callee5);
  }));
  return _queryFlowCopyMan.apply(this, arguments);
}
export function weatherInfo() {
  return _weatherInfo.apply(this, arguments);
}

//已办
function _weatherInfo() {
  _weatherInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, request('/weatherService/getWeather', METHOD.GET, null));
      }
    }, _callee6);
  }));
  return _weatherInfo.apply(this, arguments);
}
export function finishedList(_x10, _x11, _x12) {
  return _finishedList.apply(this, arguments);
}
function _finishedList() {
  _finishedList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(page, limit, param) {
    var data;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          data = {
            currentNo: page,
            pageSize: limit
          };
          return _context7.a(2, request('/flowable/task/finishedList', METHOD.POST, data));
      }
    }, _callee7);
  }));
  return _finishedList.apply(this, arguments);
}